import React from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { InsertLink, LinkOff } from "@material-ui/icons";

// Tema customizado para Material-UI com cores roxas
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#8e44ad',
    },
  },
});

function Tabdata({
  values,
  touched,
  errors,
  handleChange,
  onTestConnect,
  connected,
  isLoading
}) {
  return (
    <ThemeProvider theme={theme}>
      <FormContainer>
        <ContainerFields hidden={values.id === 0}>
          <FieldContainer>
            <StyledTextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              disabled
              id="id"
              name="id"
              label="ID"
              value={values.id}
              onChange={handleChange}
              error={touched.id && Boolean(errors.id)}
              helperText={touched.id && errors.id}
              autoComplete="off"
              variant="outlined"
            />
            <FormLabel>
              <StyledCheckbox
                id="ativo"
                name="ativo"
                checked={values.ativo}
                onChange={handleChange}
                color="primary"
              />
              <CheckboxText>Ativo</CheckboxText>
            </FormLabel>
          </FieldContainer>
        </ContainerFields>
        <SectionTitle>Informações Básicas</SectionTitle>
        <ContainerFields>
          <FieldContainer>
            <StyledTextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="cnpj"
              name="cnpj"
              label="CNPJ"
              placeholder="00.000.000/0000-00"
              value={values.cnpj}
              onChange={handleChange}
              error={touched.cnpj && Boolean(errors.cnpj)}
              helperText={touched.cnpj && errors.cnpj}
              autoComplete="off"
              variant="outlined"
            />
          </FieldContainer>
          <FieldContainer>
            <StyledTextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="name"
              name="name"
              label="Nome"
              placeholder="Nome da empresa"
              value={values.name}
              onChange={handleChange}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
              autoComplete="off"
              variant="outlined"
            />
          </FieldContainer>
        </ContainerFields>
        <ContainerFields>
          <FieldContainer fullWidth>
            <StyledTextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="description"
              name="description"
              label="Descrição"
              placeholder="Descrição da empresa"
              value={values.description}
              onChange={handleChange}
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
              autoComplete="off"
              variant="outlined"
              multiline
              rows={2}
            />
          </FieldContainer>
        </ContainerFields>

        <SectionDivider />
        <SectionTitleContainer>
          <SectionTitle>Configurações SAP</SectionTitle>
          {onTestConnect && (
            <ConnectionButton
              onClick={onTestConnect}
              connected={connected}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={18} style={{ color: 'white' }} />
              ) : (
                <Tooltip title={connected ? "Conectado ao SAP" : "Testar conexão SAP"}>
                  {connected ? <InsertLink /> : <LinkOff />}
                </Tooltip>
              )}
            </ConnectionButton>
          )}
        </SectionTitleContainer>
        <ContainerFields>
          <FieldContainer>
            <StyledTextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="database"
              name="database"
              label="Banco de dados SAP"
              placeholder="Nome do banco"
              value={values.database}
              onChange={handleChange}
              error={touched.database && Boolean(errors.database)}
              helperText={touched.database && errors.database}
              autoComplete="off"
              variant="outlined"
            />
          </FieldContainer>
          <FieldContainer>
            <StyledTextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="login"
              name="login"
              label="Login SAP"
              placeholder="Usuário"
              value={values.login}
              onChange={handleChange}
              error={touched.login && Boolean(errors.login)}
              helperText={touched.login && errors.login}
              autoComplete="off"
              variant="outlined"
              type="password"
            />
          </FieldContainer>
        </ContainerFields>
        <ContainerFields>
          <FieldContainer>
            <StyledTextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="password"
              name="password"
              label="Senha SAP"
              placeholder="Senha"
              type="password"
              value={values.password}
              onChange={handleChange}
              error={touched.password && Boolean(errors.password)}
              helperText={touched.password && errors.password}
              autoComplete="off"
              variant="outlined"
            />
          </FieldContainer>
          <FieldContainer>
            <StyledTextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="url"
              name="url"
              label="URL Service Layer SAP"
              placeholder="https://servicelayer.sample:00000/b1s/v1"
              value={values.url}
              onChange={handleChange}
              error={touched.url && Boolean(errors.url)}
              helperText={touched.url && errors.url}
              autoComplete="off"
              variant="outlined"
            />
          </FieldContainer>
        </ContainerFields>
      </FormContainer>
    </ThemeProvider>
  );
}

export default Tabdata;

const FormContainer = styled.div`
  width: 100%;
`;

const SectionTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0 16px 0;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
  display: flex;
  align-items: center;

  &:first-of-type {
    margin-top: 0;
  }
`;

const ConnectionButton = styled.button`
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  background: ${props => {
    if (props.disabled) return '#e0e0e0';
    return props.connected
      ? 'linear-gradient(135deg, #27ae60 0%, #229954 100%)'
      : 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)';
  }};
  color: white;

  &:hover {
    transform: ${props => props.disabled ? 'none' : 'scale(1.1)'};
    box-shadow: ${props => {
      if (props.disabled) return 'none';
      return props.connected
        ? '0 4px 12px rgba(39, 174, 96, 0.4)'
        : '0 4px 12px rgba(243, 156, 18, 0.4)';
    }};
  }

  svg {
    font-size: 20px;
  }
`;

const SectionDivider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, #e8e8e8 0%, transparent 100%);
  margin: 24px 0;
`;

const ContainerFields = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
`;

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.fullWidth && 'grid-column: 1 / -1;'}
`;

const StyledTextField = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      border-radius: 10px;
      font-family: 'Mulish', sans-serif;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 2px 8px rgba(142, 68, 173, 0.1);
      }

      &.Mui-focused {
        box-shadow: 0 4px 12px rgba(142, 68, 173, 0.2);
      }
    }

    .MuiInputLabel-outlined {
      font-family: 'Mulish', sans-serif;
      font-weight: 600;
      color: #2c3e50;
    }

    .MuiOutlinedInput-input {
      font-family: 'Mulish', sans-serif;
    }

    .MuiFormHelperText-root {
      font-family: 'Mulish', sans-serif;
    }
  }
`;

const FormLabel = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: rgba(142, 68, 173, 0.05);
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(142, 68, 173, 0.1);
  }
`;

const StyledCheckbox = styled(Checkbox)`
  && {
    color: #8e44ad;

    &.Mui-checked {
      color: #8e44ad;
    }
  }
`;

const CheckboxText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  font-family: 'Mulish', sans-serif;
`;
